<form [formGroup]="formGroup" class="step1-container">
    <mat-form-field appearance="outline" class="w-100 py-1" subscriptSizing="dynamic">
        <mat-label>{{ 'app.settings.user_create.step1.search_label' | translate }}</mat-label>
        <mat-icon matPrefix class="search-icon icon-sm">search</mat-icon>
        <input matInput type="text" formControlName="userSearch" [matAutocomplete]="auto"
            [placeholder]="'app.settings.user_create.step1.search_placeholder' | translate">

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="onUserSelected($event)">
            @if (facade.isSearchUserLoading()) {
            <mat-option disabled>
                <div class="autocomplete-loading d-flex align-items-center gap-sm">
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>{{ 'app.settings.user_create.step1.searching' | translate }}</span>
                </div>
            </mat-option>
            } @else {

            @if (formGroup.get('userSearch')?.value && 1 < formGroup.get('userSearch')?.value.length &&
                formGroup.get('userSearch')?.value.length < 3) { <mat-option disabled class="no-results-option">
                <div class="autocomplete-no-results d-flex align-items-center gap-sm">
                    <mat-icon class="no-results-icon icon-sm">person_search</mat-icon>
                    <span>{{ 'app.settings.user_create.step1.min_chars' | translate }}</span>
                </div>
                </mat-option>
                }@else if(facade.searchUserResults().length == 0 &&
                formGroup.get('userSearch')?.value &&
                formGroup.get('userSearch')?.value.length >= 3){
                <mat-option disabled class="no-results-option">
                    <div class="autocomplete-no-results d-flex align-items-center gap-sm">
                        <mat-icon class="no-results-icon icon-sm">person_search</mat-icon>
                        <span>
                            {{ 'app.settings.user_create.step1.no_results_prefix' | translate }}
                            <strong>"{{formGroup.get('userSearch')?.value}}"</strong>.
                        </span>
                    </div>
                </mat-option>
                }@else{
                @for (user of facade.searchUserResults(); track user.id) {
                <mat-option [value]="user" class="user-option-item compact-option">
                    <div class="autocomplete-option">
                        <span class="option-name ms-2">{{ user.displayName }}</span>
                        <span class="option-email ms-3">{{ user.userPrincipalName }}</span>
                    </div>
                </mat-option>
                }
                }
                }
        </mat-autocomplete>
    </mat-form-field>

    <div class="user-details-card h-75 d-block shadow-sm mt-3">
        <div class="card-header d-flex align-items-center p-2 my-2">
            <mat-icon class="card-header-icon mr-2 icon-sm">person_pin</mat-icon>
            <h4 class="card-title m-0">{{ 'app.settings.user_create.step1.card_title' | translate }}</h4>
        </div>
        @if (facade.selectedUser(); as user) {
        <div class="row g-2 px-3 pb-2">
            <div class="col-12 col-6 col-lg-3 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.first_name' | translate
                    }}</span>
                <span class="detail-value">{{ user.givenName || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 col-lg-3 detail-item">
                <span class="detail-label">{{ 'app.settings.user_create.step1.fields.last_name' | translate
                    }}</span>
                <span class="detail-value">{{ user.surname || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 col-lg-6 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.display_name' | translate
                    }}</span>
                <span class="detail-value fw-bold">{{ user.displayName || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 col-lg-6 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.job_title' | translate
                    }}</span>
                <span class="detail-value">{{ user.jobTitle || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 col-lg-6 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.office_location' |
                    translate }}</span>
                <span class="detail-value">{{ user.officeLocation || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.email_upn' | translate
                    }}</span>
                <span class="detail-value">{{ user.userPrincipalName || 'N/A' }}</span>
            </div>
            <div class="col-12 col-6 detail-item">
                <span class="detail-label me-1">{{ 'app.settings.user_create.step1.fields.employee_id' | translate
                    }}</span>
                <span class="detail-value">{{ user.employeeId || 'N/A' }}</span>
            </div>
        </div>
        } @else {
        <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center p-4 my-5">
            <mat-icon class="info-icon icon-sm mr-2">info</mat-icon>
            <span>{{ 'app.settings.user_create.step1.empty_state' | translate }}</span>
        </div>
        }
    </div>

    <div class="stepper-actions d-flex justify-content-end mt-3">
        <button mat-flat-button color="primary" matStepperNext [disabled]="!facade.selectedUser()"
            class="rounded-full button-compact">
            {{ 'app.settings.user_create.step1.continue_button' | translate }}
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
        </button>
    </div>
</form>